export const driverPluralMapping = {
  '=0': 'No drivers',
  '=1': '1 driver',
  other: '# drivers',
};
